<template>
  <CustomerForm
    :title="$t('customer.form.addTitle')"
    :submit-text="$t('customer.form.add')"
    :on-submit="handleAdd"
  />
</template>

<script setup>
import { useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
import { ElMessage } from 'element-plus'
import { createCustomer } from '@/api/customer'
import CustomerForm from '@/components/CustomerForm.vue'

const { t } = useI18n()
const router = useRouter()

const handleAdd = async (formData) => {
  await createCustomer(formData)
  ElMessage.success(t('customer.form.addSuccess'))
  router.push('/customer')
}
</script>
